import { TableColumn } from "react-data-table-component";
import { Fragment, useState } from "react";
import { Edit3, Trash2, Download } from "react-feather";
import { Badges, Btn, H3, P } from "../../AbstractElements";
import { CustomCellInterFace } from "../../Types/TablesType";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { downloadAPIAttachments } from "../../Utils";
import axios from "axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Modal, ModalHeader } from "reactstrap";

//MODAL
import UpdateAttachmentModal from "../../Components/UiKits/Modal/Applicants/UpdateAttachment";

//SERVICES
import {
  APPLICANT_ATTACHMENTS_QUERY_KEY,
  VIEW_APPLATTACHMENTS_QUERY_KEY,
  applicantAttachmentsService,
} from "../../Services/applicantsattachmentService";

//TYPE
import { ViewApplicantAttachments } from "../../Types/Applicants/ApplicantsAttachments";


const ActionCell = ({ row }: { row: ViewApplicantAttachments }) => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const [Updatemodal, setUpdateModal] = useState(false);
  const [Candidatemodal, setCandidatemodal] = useState(false);
  const [selectedApplNo, setSelectedApplNo] = useState<string>("");

  const toggleCandidateModal = () => {
    setCandidatemodal(!Candidatemodal);
  };

  const Updatetoggle = () => {
    setUpdateModal(!Updatemodal);
  };
  
  const toggleMutation = useMutation({
    mutationFn: applicantAttachmentsService.toggleStatus,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: VIEW_APPLATTACHMENTS_QUERY_KEY });
      Swal.close();
      Swal.fire({
        allowOutsideClick: false,
        allowEscapeKey: false,
        icon: "success",
        title: "Transaction Successful",
        text: "Attached File has been removed successfully.",
        confirmButtonColor: "#4e73df",
      });
    },
    onError: (error: any) => {
      Swal.close();
      Swal.fire({
        icon: "error",
        title: "Transaction Failed",
        text: (error.response?.data?.message || "Failed to Remove Attachment please reload and try again."),
        confirmButtonColor: "#4e73df",
      });
    },
  });

  const handleDownload = async () => {
    try {
      const response =
        await applicantAttachmentsService.downloadAttachment(
          row.file_path
        );

      const url = window.URL.createObjectURL(response.data);

      const link = document.createElement("a");
      link.href = url;
      link.download = row.file_name;

      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

    } catch (error: any) {

      Swal.fire({
        icon: "error",
        title: `ERROR ${error.response?.status || ""}`,
        text: "Attachment Not Found.",
        confirmButtonColor: "#4e73df",
      });
      
    }
  };

  const handleRemove = () => {
    Swal.fire({
      icon: "question",
      html: `Are you sure you want to remove this attachment?`,
      showCancelButton: true,
  
      confirmButtonText: '<i class="fa fa-trash"></i> Remove Attachment',
      cancelButtonText: '<i class="fa fa-times"></i> Cancel',

      confirmButtonColor: "#4e73df", // Primary
      cancelButtonColor: "#dc3545",  // Danger
      allowOutsideClick: false,
      allowEscapeKey: false,
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: "Removing Attachment...",
          text: "Please wait while your attachment file is being removed.",
          allowOutsideClick: false,
          allowEscapeKey: false,
          didOpen: () => {
            Swal.showLoading();
          },
        });
        toggleMutation.mutate(row.id);
      }
    });
  };

  return (
    <div className="d-flex align-items-center gap-2">
      <Btn size="sm" color="primary" className="px-2" onClick={handleDownload}>
        <Download size={11} /> Download
      </Btn>
      <Btn size="sm" color="info" className="px-2" onClick={Updatetoggle}>
        <Edit3 size={11} /> Update
      </Btn>
      <Btn size="sm" color="danger" className="px-2" onClick={handleRemove}>
        <Trash2 size={11} /> Remove
      </Btn>
      <UpdateAttachmentModal modal={Updatemodal} attachment_id={row.id} category_id={row.category_id} file_name={row.file_name} toggle={Updatetoggle} />
    </div>
  );
};

export const AttachmeneTableColumn: TableColumn<ViewApplicantAttachments>[] = [
  {
    name: "File Name",
    selector: (row) => row.file_name,
    cell: (row) => (
      <div style={{ whiteSpace: "pre-line" }}>
        {row.file_name}
      </div>
    ),
    sortable: true,
    center: false,
  },
  {
    name: "Attachment Category",
    selector: (row) => row.category,
    sortable: true,
    center: false,
  },
  {
    name: "DATE MODIFIED",
    selector: (row) => row.updated_date,
    cell: (row) => (
      <div style={{ whiteSpace: "pre-line" }}>
        {row.updated_by_user}
        {"\n"}
        {row.updated_date}
      </div>
    ),
    width: "250px",
    sortable: true,
    center: false,
  },
  {
    name: "ACTION",
    sortable: false,
    center: false,
    cell: (row) => <ActionCell row={row} />,
  },
];
